import {
    StyledFooterWrapper,
    StyledFooterImg,
    StyledFooterSectionText,
    StyledFooterSectionTitle,
    StyledFooterContnetWrapper,
    StyledFooterGridItem,
    StyledFooterGridContainer,
} from "./Footer.styled";
import Box from "@mui/material/Box";
import Neo_CRF_logo from "commons/assets/logo-nv.svg";
import { PROJECT_PRIMARY_EMAIL } from "commons/constants/env";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();

    return (
        <StyledFooterWrapper>
            <StyledFooterContnetWrapper>
                <StyledFooterGridContainer>
                    <StyledFooterGridItem>
                        <Box flexGrow={1} display="flex" alignItems="center" pb={1}>
                            <StyledFooterImg src={Neo_CRF_logo} alt="NeoCRF" marginRight={24}/>
                            <Box display="flex" flexDirection="column">
                                <StyledFooterSectionTitle></StyledFooterSectionTitle>
                                <StyledFooterSectionText>
                                    Neo-Vinci sp. z o.o.
                                </StyledFooterSectionText>
                                <StyledFooterSectionText>
                                    ul. Puławska 14 | 02-512 Warszawa
                                </StyledFooterSectionText>
                            </Box>
                        </Box>
                    </StyledFooterGridItem>
                    <StyledFooterGridItem>
                        <Box flexGrow={1} display="flex" pb={1}>
                            <Box display="flex" flexDirection="column">
                                <StyledFooterSectionTitle>
                                    {t('Contact')}:
                                </StyledFooterSectionTitle>
                                <StyledFooterSectionText>
                                    e-mail: {PROJECT_PRIMARY_EMAIL}
                                </StyledFooterSectionText>
                            </Box>
                        </Box>
                    </StyledFooterGridItem>
                </StyledFooterGridContainer>
            </StyledFooterContnetWrapper>
        </StyledFooterWrapper>
    );
};

export default Footer;
